var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"type":"line","options":_vm.compoundChart,"series":_vm.compoundSeries,"height":_vm.height,"width":_vm.width}})}
var staticRenderFns = []

export { render, staticRenderFns }